import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type Store = Static<typeof StoreSchema>;
export const StoreSchema = Type.Object(
  {
    id: Type.String(),
    displayName: Type.String(),
  },
  { $id: 'StoreSchema' }
);

export type Stores = Static<typeof StoresSchema>;
export const StoresSchema = Type.Array(StoreSchema, { $id: 'StoresSchema' });
